// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/hightechlive/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const hightechliveDE: PageEntry = {
  id: "post.hightechlive",
  locale: "de",
  slug: "hightechlive",
  seo: {
    title: "Save the date: Hightech live! im Haus Dietz | Dietz GmbH",
    description: "Save the date: Hightech live! im Haus Dietz",
  },
  type: "post",
  h1: "Save the date: Hightech live! im Haus Dietz",
  blocks: [
    { kind: "heading", level: 2, text: "Save the date: Hightech live! im Haus Dietz" },
    { kind: "paragraph", text: "Bereits im letzten Jahr gestalteten wir den Projekttag „Hightech live!“ in Zusammenarbeit mit dem bbw (Bildungswerk der Bayerischen Wirtschaft e.V.) und der Schulewirtschaft Bayern. Im Gegensatz zum vergangenen Projekttag, der im Online-Format stattfand, hoffen wir ihn in diesem Jahr in Präsenz durchführen zu können. Lerne die technischen Ausbildungsberufe in deiner Region kennen – mit Hightech live!" },
    { kind: "paragraph", text: "Vielfältiges und interessantes Programm von 8.00 – ca. 16.30 Uhr:" },
    { kind: "list", items: ["Vorstellung des Unternehmens", "Arbeiten an einem eigenen Werkstück", "Vorstellung der Ausbildungsberufe durch unsere Azubis", "Tipps & Tricks rund um die Bewerbung", "Feierliche Abschlussrunde"] },
    { kind: "paragraph", text: "Hier geht’s zur Anmeldung" },
    { kind: "heading", level: 2, text: "Ein Projekt der Bildungsinitiative Technik-Zukunft in Bayern 4.0 zur Berufsorientierung von Schüler*innen." },
    { kind: "paragraph", text: "Wann? Mittwoch, 17.11.2021" },
    { kind: "paragraph", text: "Wo? Dietz GmbH (Am Floßgraben 10, 96465 Neustadt bei Coburg)" },
    { kind: "paragraph", text: "Wer? Schüler*innen der 8. und 9. Klasse" },
    { kind: "paragraph", text: "Anmeldeschluss : Mittwoch, 03.11.2021." },
    { kind: "paragraph", text: "Die Teilnahme ist kostenfrei!" }
  ],
};
